module.exports = __webpack_public_path__ + "img/logo-app.ce064799.png";